import AddQuestionButton from "./AddQuestionButton";
import EstimationFunctionButton from "./EstimationFunctionButton";
import PipelineButton from "./PipelineButton";
import ConversationInfoPanel from "./ConversationInfoPanel";
import ConversationTagsButton from "./ConversationTagsButton";
import AssignUserButton from "./AssignUserButton";
import ToolbarSelect from "./ToolbarSelect";
import useConversationLookups from "./useConversationLookups";
import useEstimationGroups from "./useEstimationGroups";

const PUBLISH_OPTIONS = [
    { id: 1, name: "Опубліковано" },
    { id: 0, name: "Чернетка" },
];

export default function ConversationToolbar({
    conversation,
    estimationGroups,
    stages,
    botErrors,
    createQuestion,
    updateConversation,
    reloadEstimationGroups,
    reloadConversation,
}) {
    const { estimationFunctions, stageTypes, levels, conversationTypes } = useConversationLookups();
    const { addGroup, removeGroup } = useEstimationGroups(conversation?.id, reloadEstimationGroups);

    return (
        <div className="canvas-instruments-pannel">
            <AddQuestionButton onCreate={createQuestion} />

            <EstimationFunctionButton
                conversation={conversation}
                estimationFunctions={estimationFunctions}
                estimationGroups={estimationGroups}
                onUpdateConversation={updateConversation}
                onAddGroup={addGroup}
                onRemoveGroup={removeGroup}
            />

            <PipelineButton conversation={conversation} stageTypes={stageTypes} stages={stages} onUpdateConversation={updateConversation} />

            <ConversationTagsButton conversation={conversation} onTagsChanged={reloadConversation} />

            <AssignUserButton conversation={conversation} />

            <ToolbarSelect
                label="Рівень"
                value={conversation?.level?.id}
                options={levels}
                placeholder="Рівень"
                onChange={(value) => updateConversation({ level: value })}
            />

            <ToolbarSelect
                label="Тип"
                value={conversation?.typeId?.id}
                options={conversationTypes}
                placeholder="Тип"
                onChange={(value) => updateConversation({ typeId: value })}
            />

            <ToolbarSelect
                label="Статус"
                value={conversation?.isPublic}
                options={PUBLISH_OPTIONS}
                placeholder="Статус"
                onChange={(value) => updateConversation({ isPublic: value })}
            />

            <ConversationInfoPanel conversation={conversation} estimationGroups={estimationGroups} stages={stages} botErrors={botErrors} />
        </div>
    );
}
